import * as React from 'react';
import * as Sebrae from '@sebrae/react-core';
import { classificationRoutePaths } from './models/path-model';
import { Role } from '../main/models/role-model';

const ClassificationStoriesListPage = React.lazy(
  () => import('./pages/classification-stories-list-page'),
);
const ClassificationStoryResumePage = React.lazy(
  () => import('./pages/classification-story-resume-page'),
);

export const classificationRoutes: Sebrae.RoutesConfig = [
  {
    routePath: classificationRoutePaths.home,
    pageToRender: <ClassificationStoriesListPage />,
    ifHaveTheseRoles: [Role.admin, Role.externalAgency],
  },
  {
    routePath: classificationRoutePaths.storiesList,
    ifHaveTheseRoles: [Role.admin, Role.externalAgency],
    pageToRender: <ClassificationStoriesListPage />,
  },
  {
    routePath: classificationRoutePaths.storyResume,
    ifHaveTheseRoles: [Role.admin, Role.externalAgency],
    pageToRender: <ClassificationStoryResumePage />,
  },
];
